export default __webpack_public_path__ + "static/media/kpi-visits.95cd3d1f.svg";